<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <h2 class="mt-5">Custom Columns</h2>
            </v-col>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="columns"
                    mobile-breakpoint="100"
                    class="elevation-1 datat"
                >
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-btn small @click="edit(item)" icon color="orange">
                            <v-icon color="orange">mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row>
            <v-dialog v-model="dialog" max-width="600">
                <v-card>
                    <v-card-title>Edit Column</v-card-title>
                    <v-card-text>
                        <v-text-field label="Label" v-model="label" outlined></v-text-field>
                        <v-text-field label="Order" v-model="order" type="number" outlined></v-text-field>
                        <v-checkbox v-model="enable" label="Enable"></v-checkbox>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn @click="updateColumn" class="gradient-button">Update</v-btn>
                        <v-btn @click="close" color="red">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import { supabase } from '../supabase';
export default {
    data:() => ({
        headers: [
            { text: 'Order', value: 'order', sortable: true, align: 'center' },
            { text: 'Column', value: 'cno', sortable: false, align: 'center' },
            { text: 'Label', value: 'label', sortable: false, align: 'center' },
            { text: 'Enabled', value: 'enable', sortable: true, align: 'center' },
            { text: 'Actions', value: 'actions', sortable: false, align: 'center' },
        ],
        label: '',
        enable: false,
        columns: [],
        dialog: false,
        id: '',
        order: 0,
        loading: false
    }),

    methods: {
        async getColumns() {
            const { data, error } = await supabase
                .from('table_map')
                .select('*')
                .order('order', { ascending: true })
            if (error) {
                console.error('Error fetching positions:', error);
                this.loading = false;
            } else {
                this.columns = data;
                this.loading = false;
            }
        },

        edit(item) {
            this.label = item.label
            this.enable = item.enable
            this.order = item.order
            this.id = item.id
            this.dialog = true
        },

        async updateColumn() {
            this.loading = true
            const { data, error } = await supabase
                .from('table_map')
                .update({ label: this.label, enable: this.enable, order: this.order })
                .eq('id', this.id)
            if (error) {
                this.$store.dispatch('createAlert',{type: 'error', message: error.message})
                this.close()
            } else {
                this.$store.dispatch('createAlert',{type: 'success', message: 'Column updated!'})
                this.getColumns()
                console.log(data);
                this.close()
            }
        },

        close() {
            this.label = ''
            this.enable = false
            this.id = null
            this.dialog = false
            this.loading = false
        }
    },

    mounted() {
        if(this.columns.length == 0) {
            this.getColumns()
        }
    }
}
</script>